import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=60291dc6&scoped=true"
import script from "./Measurements.vue?vue&type=script&lang=js"
export * from "./Measurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60291dc6",
  null
  
)

export default component.exports